import { ComingSoon } from "@/components/ComingSoon";

export function ComingSoonPage({ feature }: { feature: string }) {
  return (
    <div className="page">
      <ComingSoon feature={feature} />
    </div>
  );
}
